export default __webpack_public_path__ + "static/media/Icon-Check.67911814.png";